import { snakeCase, camelCase } from '@ridi/object-case-converter';
import { action } from 'mobx';
import axios from '../../../../libs/axios_csrf';
import Attachment from '../models/Attachment';

export default class AttachmentsStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  create(file, attachable) {
    return new Promise(async (resolve, reject) => {
      if (attachable.persisted) {
        const attachmentData = new FormData();
        attachmentData.append('attachment[attachable_id]', attachable.id);
        attachmentData.append(
          'attachment[attachable_type]',
          attachable.constructor.backendModelName
        );
        if (file.isExternal) {
          attachmentData.append('attachment[external_link]', file.url);
          attachmentData.append('attachment[external_name]', file.name);
        } else {
          // File to upload
          attachmentData.append('attachment[attach]', file);
        }
        await this.createBackend(attachmentData, attachable);
        resolve();
      }
    });
  }

  attachmentsFromJsonArray(jsonArray, attachable) {
    return jsonArray.map(attachment =>
      Attachment.deserialize(attachment, attachable, this)
    );
  }

  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BACKEND CONNECTIONS
  createBackend(attachmentData, attachable) {
    return new Promise((resolve, reject) => {
      axios
        .post('/attachments', attachmentData)
        .then(
          action(response => {
            const attachment = Attachment.deserialize(
              camelCase(response.data),
              attachable,
              this
            );
            resolve();
          })
        )
        .catch(
          action(error => {
            // console.log("error.attach: ", error.response.data.attach[0]);
            // this.rootStore.generateAlert({type: 'danger', headline: "attachment_error"});
            reject();
          })
        );
    });
  }

  destroy(attachment) {
    axios
      .delete(`/attachments/${attachment.id}`)
      .then(response => {})
      .catch(errors => {
        console.log(errors);
      });
  }

  updateBackend(attachment) {
    axios
      .patch(`/attachments/${attachment.id}`, {
        attachment: snakeCase(attachment.serialize())
      })
      .then(response => {
        // nothing
      })
      .catch(errors => {
        console.log(errors);
      });
  }
  // end BACKEND CONNECTIONS
  // //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
